import { Button, Input, Space, Typography } from "antd";
import React, { useState } from "react";
import cookie from "react-cookies";
import constants from "../../Constants";

const { Text } = Typography;
const baseURL = constants.baseURL;
const Authorization = () => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: cookie.load("session-id-qt"),
  },
});

function FileUpload(props) {
  const [file, setFile] = useState(null);
  const [uploadstatus, setUploadStatus] = useState(null);
  const [uploading, seUploading] = useState(false);
  const [metadata, setMetadata] = useState({
    title: props.title,
    description: props.description,
    location: props.location,
  });

  const handleMetadataChange = (e) => {
    setMetadata({ ...metadata, [e.target.name]: e.target.value });
  };

  const getPresignedUploadURL = async (file) => {
    console.log("file", file);
    const response = await fetch(baseURL + "/customer-job-file-upload-url", {
      method: "POST",
      body: JSON.stringify({
        file: {
          lastModified: file.lastModified,
          lastModifiedDate: file.lastModifiedDate,
          name: file.name,
          originalname: file.name,
          size: file.size,
          type: file.type,
          mimetype: file.mimetype,
          webkitRelativePath: file.webkitRelativePath,
        },
        filetype: file.type,
        metadata,
        orderid: props.orderid,
      }),
      ...Authorization("POST"),
    });
    console.log("response", response);
    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    } else {
      addConversation(props.orderid, file.name);
    }
    const text = await response.text();
    return text;
  };
  const addConversation = (orderid, filename) => {
    fetch(baseURL + "/customer-add-conversation", {
      method: "POST",
      body: JSON.stringify({
        orderid,
        message: "Upload started for file :: " + filename,
      }),
      ...Authorization("POST"),
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return;
    seUploading(true);
    setUploadStatus(null);
    try {
      const uploadURL = await getPresignedUploadURL(file);

      // Now upload the file to S3 using the pre-signed URL
      const s3UploadResponse = await fetch(uploadURL, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type, // Make sure the content type matches
        },
      });
      console.log("s3UploadResponse", s3UploadResponse);
      if (s3UploadResponse.ok) {
        console.log("File uploaded successfully.");
        setUploadStatus("File uploaded successfully.");
        props.getOrderFiles(props.orderid);
        props.getOrderConversations(props.orderid);
        // Handle the successful upload here (e.g., update the state or notify the user)
      } else {
        console.error("File upload failed.");
        setUploadStatus("File uploaded failed.");
        console.log(s3UploadResponse);
        // Handle the upload failure here (e.g., notify the user)
      }
    } catch (error) {
      console.error("Error during the upload process:", error);
      setUploadStatus("Error uploading file.");
    } finally {
      seUploading(false);
    }
    // POST request to your Node.js server
  };

  // Function to handle the file upload upon file selection
  const setFileUpload = async (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <form onSubmit={handleSubmit} style={{ marginBottom: 20 }}>
      <Space direction="vertical" size={12} style={{ width: "100%" }}>
        {uploading && (
          <Text type="warning">Uploading your file, please wait...</Text>
        )}
        
        <div className="custom-file-upload">
          <input
            type="file"
            id="fileInput"
            onChange={setFileUpload}
            style={{ display: "none" }}
          />
          <label htmlFor="fileInput" style={{ 
            display: "inline-block",
            padding: "8px 16px",
            border: "1px solid #d9d9d9",
            borderRadius: "2px",
            cursor: "pointer",
            backgroundColor: "#fafafa",
          }}>
            Choose file
          </label>
          <span style={{ marginLeft: 8 }}>
            {file ? file.name : "No file chosen"}
          </span>
        </div>
        
        <Input
          name="title"
          placeholder="Title"
          value={metadata.title || ""}
          onChange={handleMetadataChange}
        />
        
        <Input.TextArea
          name="description"
          placeholder="Description"
          value={metadata.description || ""}
          onChange={handleMetadataChange}
          autoSize={{ minRows: 2, maxRows: 4 }}
        />
        
        <Button
          type="primary"
          htmlType="submit"
          disabled={uploading || !file || !metadata.title}
          loading={uploading}
        >
          Upload
        </Button>
        
        {uploadstatus && (
          <Text type={uploadstatus.includes("success") ? "success" : "danger"}>
            {uploadstatus}
          </Text>
        )}
      </Space>
    </form>
  );
}

export default FileUpload;
